<template>
	<div id="app" class="app column flexible" v-handle-tab :class="{'touched':$root.pointer === 'touch', 'hoverable':$root.pointer === 'mouse'}">
		<header class="page-header row rigid">
			<a v-if="referrerClientURL" class="return link" :href="referrerClientURL || appURL" title="Go Back to Previous Page"><i class="fa fa-arrow-left"></i></a>
			<a class="launch launch-nav rigid" :href="getAppURL" title="View App Launcher">
				<i class="tool-icon"></i>
			</a>
			<span class="gap"></span>
			<menu v-if="isAuthenticated">
				<dropdown-menu :user="user">

					<span v-if="referrerClientURL">
						<a href="#/" title="Optimus">Data Market</a>
						<div class="divider"></div>
					</span>

					<a target="_blank" href="http://support.initialstate.com/hc/en-us/requests/new?feedback=true" class="is-support" title="Send us your feedback">Feedback</a>
					<a href="http://support.initialstate.com/" class="is-support" target="_blank" title="Get assistance and follow changes">Support</a>
					<router-link to="/signout">Sign out</router-link>
				</dropdown-menu>
			</menu>
		</header>


		<main v-if="pageNotFound">
			<router-view/>
		</main>

		<main class="column" v-else>
			<transition name="collapse">
				<header v-show="!hideMainHeader" class="rigid pattern" :class="{'no-header':hideMainHeader}">
					<div class="content-frame">
						<h1>Integration Marketplace</h1>
						<menu class="rigid rigid tabs">
							<router-link class="tab" v-bind:class="{active: $route.name ? $route.name.startsWith('marketplace') : false}" tag="button" to="/marketplace">Browse</router-link>
							<router-link v-if="canManage" class="tab" v-bind:class="{active: $route.name==='manage'}" tag="button" to="/manage">My Integrations</router-link>
							<router-link class="tab" v-bind:class="{active: $route.name==='credits'}" tag="button" to="/credits">Credits <span v-if="creditsRemaining != null && creditsRemaining >= 0" class="badge"> {{creditsRemaining}} </span></router-link>
						</menu>
					</div>
				</header>
			</transition>

			<router-view/>
		</main>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import globalAxios from './modules/axios';
	import DropdownMenu from './components/DropdownMenu';
	import { handleTab } from './directives/handle-tab';

	export default {
		name: 'App',
		components: {
			DropdownMenu
		},
		directives: {
			handleTab
		},
		data() {
			return {
				prevPath: null
			};
		},
		computed: {
			...mapGetters([
				'isAuthenticated',
				'user',
				'credits',
				'userStatus',
				'refreshToken',
				'accessToken',
				'referrerClientURL',
				'appURL',
				'appSettingsURL',
				'appContactsURL',
				'BRAND'
			]),
			getAppURL() {
				//TODO rethink app specific controls
				return (this.BRAND.id === 'initialstate') ? this.appURL : '#/';
			},
			hideMainHeader() {
				return this.$route.meta.hideMainHeader;
			},
			pageNotFound() {
				return this.$route.name === 'unknown';
			},
			canManage() {
				return this.user && this.user.can && this.user.can('optimus:poll:list') && this.user.can('optimus:poll:delete');
			},
			creditsRemaining() {
				return this.credits && this.credits.remaining;
			}
		},
		created() {
			if (this.isAuthenticated) {
				globalAxios.defaults.headers.common['X-IS-AT'] = this.accessToken;
				this.$store.dispatch('USER_REQUEST');
			}
		}
	};
</script>

<style src="./styles/app.styl"></style>



// WEBPACK FOOTER //
// src/App.vue